import FallbackableImage from './FallbackableImage';

export default FallbackableImage;
